import { sdkRequest, translateServerErrors } from '@eb/http';
import gettext from '@eb/gettext';
import { PRICE_CALCULATOR_ENDPOINT } from '../constants';

const NOT_AUTHORIZED_ERROR = gettext(
    'You do not have permission to access the resource you requested.',
);
const IMPOSSIBLE_PRICE_ERROR = gettext(
    'When including fees in ticket price, the price must be greater than the fee.',
);
const STANDARD_SERVER_ERROR = gettext(
    'There was an issue with the server, try again',
);

const GET_SET_ERROR_SPEC = {
    NOT_AUTHORIZED: () => NOT_AUTHORIZED_ERROR,
    IMPOSSIBLE_PRICE: () => IMPOSSIBLE_PRICE_ERROR,
    default: () => STANDARD_SERVER_ERROR,
};

export const pricingCalculatorApi = (data) =>
    sdkRequest(PRICE_CALCULATOR_ENDPOINT, {
        method: 'POST',
        body: JSON.stringify(data),
    }).catch(translateServerErrors(GET_SET_ERROR_SPEC));
